import type { ReactNode } from "react";
import { Box, Button, Group, Paper, Stack, Text } from "@mantine/core";
import { Link } from "react-router-dom";
import type { EcosystemHeadNavState } from "@/pages/ecosystem-heads/ecosystemHeads.const";
import { CARD_BORDER } from "../sectorEcosystem.const";
import classes from "./SectorDashboardCard.module.css";

type SectorDashboardCardProps = {
  title: string;
  subtitle?: string;
  footerLabel?: string;
  footerTo?: string;
  footerLinkState?: EcosystemHeadNavState | { from: { pathname: string; search?: string; hash?: string } };
  footerComingSoon?: boolean;
  headerAction?: ReactNode;
  fillHeight?: boolean;
  children: ReactNode;
};

export default function SectorDashboardCard({
  title,
  subtitle,
  footerLabel,
  footerTo,
  footerLinkState,
  footerComingSoon = false,
  headerAction,
  fillHeight = true,
  children,
}: SectorDashboardCardProps) {
  return (
    <Paper
      withBorder
      radius={0}
      p="md"
      h={fillHeight ? "100%" : undefined}
      style={{
        border: CARD_BORDER,
        backgroundColor: "#fff",
        ...(fillHeight ? { display: "flex", flexDirection: "column", minHeight: 0 } : undefined),
      }}
    >
      <Stack
        gap="sm"
        h={fillHeight ? "100%" : undefined}
        style={fillHeight ? { flex: 1, minHeight: 0 } : undefined}
      >
        <Group justify="space-between" align="flex-start" wrap="wrap" gap="sm">
          <Box>
            <Text fw={700} c="#0F172A" size="sm">
              {title}
            </Text>
            {subtitle ? (
              <Text size="xs" c="dimmed" mt={2}>
                {subtitle}
              </Text>
            ) : null}
          </Box>
          {headerAction}
        </Group>
        <Box style={fillHeight ? { flex: 1, minHeight: 0 } : undefined}>{children}</Box>
        {footerComingSoon ? (
          <Button
            variant="filled"
            color="primary"
            size="xs"
            w="fit-content"
            disabled
            classNames={{ root: classes.disabledFooterButton }}
          >
            Launching Soon
          </Button>
        ) : footerLabel && footerTo ? (
          <Button
            component={Link}
            to={footerTo}
            state={footerLinkState}
            variant="filled"
            color="primary"
            size="xs"
            w="fit-content"
            classNames={{ root: classes.linkFooterButton }}
          >
            {footerLabel} →
          </Button>
        ) : null}
      </Stack>
    </Paper>
  );
}
